<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ctp" id="p0010-01-0"><a id="page4"></a><a href="#/contents#fn_3" id="sn_3">DAY 3</a></p>
<p class="ct"><a href="#/contents#fn_3">A GLIMPSE OF GOD’S GLORY</a></p>
<p class="ext"><span><i>God made two great lights—the greater light to govern the day and the lesser light to govern the night. He also made the stars. And God saw that it was good.</i></span></p>
<p class="txr"><span><span class="small">GENESIS</span> 1:16, 18</span></p>
<p class="tx1" id="p0010-04-4"><span class="dcap">A</span>s Psalm 19:1 says, the heavens truly do declare the glory of God, and those glorious heavens are mind-bogglingly vast.</p>
<p class="tx">If Earth were the size of a grape, Jupiter would be a large grapefruit; Saturn, an orange; Uranus and Neptune, lemons; and the sun’s diameter, five feet.</p>
<p class="tx">Now imagine the grape-sized Earth on the corner of a city block. The moon would be about a foot from the grape-Earth. The sun would be about a city block away—and Jupiter, five blocks away from the sun. Saturn, ten blocks; Uranus, twenty blocks; and Neptune, thirty. And you’d be the size of an atom.<sup><span href="#/chapter374#cap_1" id="wap_1" title="Link target outside of Sample">1</span></sup> And there’s the massive star Betelguese, the red supergiant Mu Cephei, and VY Canis Majoris with its 1.7-billion-mile diameter.<sup><span href="#/chapter374#cap_2" id="wap_2" title="Link target outside of Sample">2</span></sup> </p>
<p class="tx">God’s heavens declare his glory—his size, his magnificence, his grandeur, his majesty, his power, his order, his wonder. When you look at the stars, let them prompt you to worship their maker—and yours!</p>
<p class="tx2">YOUR GOD HOLDS THE PLANETS IN THEIR ORBITS <i>AND</i> NUMBERS THE HAIRS ON YOUR HEAD.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter6.vue?6066eb0e